import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import TileHero from './components/TileHero';
import TileServices from './components/TileServices';
import TileTypesElPaso from './components/TileTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import TileFAQ from './components/TileFAQ';

export default function TilePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <TileHero />
        <TileServices />
        <TileTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <TileFAQ />
      </main>
      <Footer />
    </div>
  );
}
